<template>
  <v-container v-if="(!infos) || (!units)" fluid fill-height>
    <v-layout align-center justify-center fill-height>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
  </v-container>

  <v-container v-else>
    <v-card>
      <v-toolbar dark>
        <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
        <v-toolbar-title>
          {{$t('units')}}
          <span v-if="infos.limits">{{' [Max. ' + infos.limits.max_units + ']'}}</span>
        </v-toolbar-title>
        <v-spacer />
        <duo-unit-edit icon="add"></duo-unit-edit>
      </v-toolbar>
      <v-list two-line>
        <v-list-group
          v-for="(unit, uuid) in units"
          :key="uuid"
          v-model="unitExpanded[uuid]"
          no-action
          @click="getUnitDetails(unit, uuid)"
        >
          <template v-slot:activator>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-btn icon>{{unit.address}}</v-btn>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{unit.name}}</v-list-tile-title>
                <v-list-tile-sub-title v-html="unitSubtitle(unit)"></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <duo-unit-edit :unitObject="unit" :unitUuid="uuid"></duo-unit-edit>
              </v-list-tile-action>
              <v-list-tile-action>
                <duo-unit-invite :unitObject="unit" :unitUuid="uuid"></duo-unit-invite>
              </v-list-tile-action>
              <v-list-tile-action
                v-if="invitations[uuid] && invitations[uuid].length == 0 && users[uuid] && users[uuid].length == 0"
              >
                <!--<duo-unit-remove :unitObject="unit" :unitUuid="uuid"></duo-unit-remove>-->
                <control-remove
                  action="duo/removeUnit"
                  :object_identifier="unit.name"
                  :object="{uuid: uuid}"
                ></control-remove>
              </v-list-tile-action>
            </v-list-tile>
          </template>
          <v-container v-if="!invitations[uuid]" fluid>
            <v-layout align-center justify-center>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
          <v-container v-else>
            <v-layout align-center justify-center>
              <v-flex xs12>
                <v-card flat>
                  <v-card-title primary-title class="headline">{{$t('flat-suspended-invitations')}}</v-card-title>
                  <v-list two-line>
                    <v-list-tile v-if="invitations[uuid].length == 0">
                      <v-list-tile-content>
                        <v-list-tile-title>{{$t('flat-no-suspended-invitations')}}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      v-for="(invitation,idx) in invitations[uuid]"
                      :key="invitation.sub"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{idx+1}}) {{invitation.email}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{$t('flat-invitation-sent-at-date', {date: invitation.timestamp ? $d(invitation.timestamp, 'long') : ' - empty - '})}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <control-remove
                          action="duo/removeInvitation"
                          :object_identifier="invitation.email"
                          :object="{code: invitation.code, flat: uuid}"
                        ></control-remove>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container v-if="!users[uuid]" fluid>
            <v-layout align-center justify-center>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
          <v-container v-else>
            <v-layout align-center justify-center>
              <v-flex xs12>
                <v-card flat>
                  <v-card-title primary-title class="headline">{{$t('flat-related-users')}}</v-card-title>
                  <v-list two-line>
                    <v-list-tile v-if="users[uuid].length == 0">
                      <v-list-tile-content>
                        <v-list-tile-title>{{$t('flat-no-related-users')}}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile v-else v-for="(user,idx) in users[uuid]" :key="user.sub">
                      <v-list-tile-content>
                        <v-list-tile-title>{{idx+1}}) {{user.email}}</v-list-tile-title>
                        <v-list-tile-sub-title>{{user.timestamp}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <control-remove
                          action="duo/removeUser"
                          :object_identifier="user.email"
                          :object="{username: user.sub, flat: uuid}"
                        ></control-remove>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-group>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DuoUnitEdit from "./DuoUnitEdit.vue";
import DuoUnitInvite from "./DuoUnitInvite.vue";
import ControlRemove from "./ControlRemove.vue";

export default {
  name: "duo-units",
  components: {
    DuoUnitEdit,
    DuoUnitInvite,
    ControlRemove
  },
  mounted() {
    this.$store.dispatch("info/fetchInfo").then(() => {
      console.log("Loading Complete");
    });
    this.$store.dispatch("duo/units").then(() => {
      console.log("Loading Complete");
    });
  },
  computed: {
    ...mapState("duo", ["loading", "units", "invitations", "users"]),
    ...mapState("info", ["infos"])
  },
  methods: {
    async getUnitDetails(unit, uuid) {
      if (!this.invitations[uuid]) await this.getInvitations(uuid);
      if (!this.users[uuid]) await this.getUsers(uuid);
    },
    async getInvitations(uuid) {
      await this.$store.dispatch("duo/invitations", uuid);
    },
    async getUsers(uuid) {
      await this.$store.dispatch("duo/users", uuid);
    },
    unitSubtitle(unit) {
      return `<span class="text--primary">${unit.location}</span> &mdash; ${unit.note}`;
    }
  },

  data() {
    return {
      unitExpanded: [] //indica se una unità abitativa è aperta e quindi sono visualizzati gli inviti in sospeso e gli utenti associati
    };
  }
};
</script>

<style>
</style>
